import React, {Component} from 'react'
import {VmPicker, VmView} from 'components'
import VmIndexRead from 'components/template/VmIndexRead'
import axios from 'axios'
import QueryString from 'qs'
import AlertYesNo from 'components/AlertYesNo'
import AlertOk from 'components/AlertOk'
import {Navigate, useSearchParams} from 'react-router-dom'
import {VmCheckIcon} from 'components/icons/solid'

class PrdDiagnosa extends Component {
  fields = [
    {
      key: 'etinama',
      _style: {fontWeight: 'bold'},
      className: 'text-zinc-600 pb-2 pt-6',
      // containerClassName: '',
    },
    {
      key: 'etiketerangan',
      // _style: {fontWeight: 'bold'},
      className: 'text-zinc-600 pb-2 border-blue-500 border-b-2',
      // containerClassName: '',
    },
  ]

  fieldsDesktop = [
    {
      key: 'etinama',
      label: 'Nama',
      _style: {fontWeight: 'bold'},
      className: 'text-[#3B82F6] mt-6',
      sorter: true,
    },
    {
      key: 'etiketerangan',
      label: 'Keterangan',
      _style: {fontWeight: 'bold'},
      className: 'text-[#3B82F6] mt-6',
      sorter: true,
    },
    {
      key: 'etiaktif',
      type: 'map',
      mapValue: {1: 'Aktif', 2: 'Non Aktif'},
      label: 'Status',
      _style: {fontWeight: 'bold'},
      className: 'text-[#3B82F6] pb-2 border-blue-500 border-b-2',
      sorter: false,
      filterType: 'select',
      filterValue: [
        {value: 1, text: 'Aktif'},
        {value: 2, text: 'Non Aktif'},
      ],
      // containerClassName: '',
    },
  ]

  constructor(props) {
    super(props)

    const {searchParams} = props
    this.state = {
      etiid: 0,
      prevItem: {},
      tambah: false,
      ubah: false,
      limit: 10, // Limit data per page
      data: [],
      itemsCount: 0,
      uid: searchParams.get('dctid'),
      fetchingMore: false,
      gettingInitialData: true,
      hasMoreItems: true,
      device: 'mobile', // Bisa Web (Tabel) / Mobile (List)
      cari: '', // Value pencarian user

      // Filter untuk pencarian web
      sort: '',
      activePage: 1,

      etinama: '',
      etiaktif: 1,
      etiketerangan: '',
    }
  }

  componentDidMount() {
    this.detectDevice()
  }

  detectDevice = () => {
    let isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )

    this.setState({device: isMobile ? 'mobile' : 'web'}, this.getInitialData)
  }

  getInitialData = (additionalParams = {}) => {
    const {etiaktif, etinama, etiketerangan, sort} = this.state
    let limit = 10
    let offset = (this.state.activePage - 1) * limit
    this.setState({gettingInitialData: true})

    let params = {
      a: 'dk13',
      reg: 'dbdok',
      uid: this.state.uid,
      etiaktif,
      etiketerangan,
      etinama,
      device: this.state.device,
      limit,
      offset,
      sort,
    }

    if (this.state.device == 'web') {
      params = {...params, ...additionalParams}
    } else {
      params = {
        ...params,
        cari: this.state.cari,
        offset: 0,
        ...additionalParams,
      }
    }

    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-etiket/index',
        QueryString.stringify(params)
      )
      .then(({data: res}) => {
        this.setState({data: res})

        if (res.length < 10) {
          this.setState({hasMoreItems: false})
        } else {
          this.setState({hasMoreItems: true})
        }
      })
      .catch(err => {
        console.log('Error get Data Etiket', err.message)
      })
      .finally(() => {
        this.setState({gettingInitialData: false})
      })

    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-etiket/index-count',
        QueryString.stringify(params)
      )
      .then(({data: res}) => {
        this.setState({itemsCount: res[0]['total']})
      })
      .catch(err => {})
  }

  refreshAfterActivateOrDelete = () => {
    if (this.state.device == 'web') {
      this.setState({activePage: 1}, this.getInitialData)
    } else {
      this.getInitialData()
    }
  }

  aktifkan = async item => {
    try {
      await axios.post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-etiket/status',
        QueryString.stringify({
          a: 'dk13',
          uid: item.uid,
          reg: 'dbdok',
          etiid: item.etiid,
          status: 1,
        })
      )

      this.refreshAfterActivateOrDelete()
    } catch (error) {
      return this.alert.show({
        message: 'Terjadi kesalahan saat nonaktifkan data Etiket. [BP-01]',
      })
    }
  }

  hapus = async item => {
    try {
      await axios.post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-etiket/status',
        QueryString.stringify({
          a: 'dk13',
          uid: item.uid,
          reg: 'dbdok',
          etiid: item.etiid,
          status: 2,
        })
      )

      this.refreshAfterActivateOrDelete()
    } catch (error) {
      return this.alert.show({
        message: 'Terjadi kesalahan saat nonaktifkan data Etiket. [BP-01]',
      })
    }
  }

  fetchMore = () => {
    const {data, cari} = this.state
    this.setState({fetchingMore: true})
    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-etiket/index',
        QueryString.stringify({
          a: 'dk13',
          reg: 'dbdok',
          uid: this.state.uid,
          offset: data.length,
          etiaktif: this.state.etiaktif,
          cari: cari,
        })
      )
      .then(({data: res}) => {
        if (res.length < 10) {
          this.setState({hasMoreItems: false})
        }
        this.setState({data: [...data, ...res]})
      })
      .catch(err => {
        console.log('Error get Data Etiket', err.message)
      })
      .finally(() => {
        this.setState({fetchingMore: false})
      })
  }

  cari = () => {
    const {cari} = this.state
    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-etiket/index',
        QueryString.stringify({
          a: 'dk13',
          reg: 'dbdok',
          uid: this.state.uid,
          cari,
        })
      )
      .then(({data: res}) => {
        console.log('Cari Data Etiket', res)
        this.setState({data: res})

        if (res.length < 10) {
          this.setState({hasMoreItems: false})
        }
      })
      .catch(err => {
        console.log('Error get Data Etiket', err.message)
      })
  }

  render() {
    const {
      data,
      hasMoreItems,
      device,
      tambah,
      ubah,
      etiid,
      etiaktif,
      itemsCount,
      uid,
      prevItem,
    } = this.state
    // console.log('hasMoreItems', hasMoreItems)
    return (
      <VmView
        className=""
        // style={{fontFamily: ''}}
      >
        <AlertOk ref={ref => (this.alert = ref)} />
        <AlertYesNo ref={ref => (this.prompt = ref)} />

        {/* Component untuk navigasi */}
        {tambah ? (
          <Navigate
            to={`/prd-data-etiket/update?dctid=${uid}`}
            replace={true}
          />
        ) : null}

        {/* Component untuk navigasi */}
        {ubah ? (
          <Navigate
            to={`/prd-data-etiket/update?dctid=${uid}&etiid=${etiid}`}
            replace={true}
            state={{item: prevItem}}
          />
        ) : null}

        {/* <p>{this.state.device}</p> */}

        <VmIndexRead
          headerTitle={'Data Etiket'}
          items={data}
          itemsCount={itemsCount}
          fields={device == 'mobile' ? this.fields : this.fieldsDesktop}
          listItemContainerClassName={'p-4 border shadow-lg m-4 rounded'}
          listSearchbar={{placeholder: 'Cari Data Etiket'}}
          // listSearchbarLeft={<p>Test halo</p>}
          listSearchbarRight={
            <VmPicker
              style={{
                // flex: 0.2,
                background:
                  'url(https://cdn-icons-png.flaticon.com/512/32/32195.png) var(--sizeIco) no-repeat #FFF',
                paddingRight: '4px !important',
                paddingLeft: '4px',
              }}
              items={[
                {value: 1, text: 'Aktif'},
                {value: 2, text: 'Non Aktif'},
              ]}
              onChange={e => {
                let val = e.target.value
                this.setState({etiaktif: val}, this.getInitialData)
                // console.log('onChange gan', val)
              }}
              placeholder={null}
              value={etiaktif}
              className="rounded-xl text-sm mb-2 py-2"
            />
          }
          listSearchbarClassname="mr-2" // Class Untuk inputan filter search bar
          onItemPress={item => {}}
          editButton={item => {
            return item.etiaktif == 1
          }}
          deleteButton={item => {
            return item.etiaktif == 1
          }}
          customButton={item => {
            if (item.etiaktif == 1) return
            return (
              <div
                onClick={() => {
                  this.aktifkan({...item, uid})
                }}
                className="flex flex-1 items-center justify-center rounded bg-green-500 ml-2 py-1"
              >
                <VmCheckIcon
                  color="white"
                  height={`${24}px`}
                  width={`${24}px`}
                />
                <p className="text-white">Aktifkan</p>
              </div>
            )
          }}
          onEditItemPress={item => {
            this.setState({etiid: item.etiid, ubah: true, prevItem: item})
          }}
          onDeleteItemPress={item => {
            this.prompt.show(
              {message: `Apakah anda yakin ingin menghapus ${item.etinama}?`},
              () => {
                this.hapus({...item, uid})
              }
            )
          }}
          // Start List Props
          hasMoreItems={hasMoreItems}
          loadMore={() => {
            // console.log('Load More', this.state.fetchingMore, this.state.gettingInitialData)
            // Jika sedang load new data / get Initial data maka ndak perlu panggil fetchMore lagi (Antisipasi data ndobel)
            if (!this.state.fetchingMore && !this.state.gettingInitialData)
              this.fetchMore()
          }}
          // End List Props
          // Start Table Props

          // End Table Props
          onFabPress={() => {
            // console.log('Fab Press')
            // redirect('/prd-mas-biaya-pemeriksaan/tambah')
            this.setState({tambah: true})
          }}
          device={device}
          onSearchSubmit={value => {
            this.setState({cari: value}, this.getInitialData)
            // this.cari(value)
          }}
          /**
           * Parameter Untuk DataTable (Versi Desktop Web)
           */
          loadingFetchData={this.state.gettingInitialData}
          totalPage={Math.ceil(this.state.itemsCount / 10)}
          activePage={this.state.activePage}
          onActivePageChange={page => {
            console.log('page change gan ', page)
            this.setState({activePage: page}, this.getInitialData)
          }}
          onColumnFilterChange={data => {
            console.log('onColumnFilterChange ', data)

            let prevFilter = {
              etinama: this.state.etinama,
              etiketerangan: this.state.etiketerangan,
              etiaktif: this.state.etiaktif,
            }
            if (JSON.stringify(data) != JSON.stringify(prevFilter)) {
              // Search hanya jika value filter kolom ada yang berubah
              this.setState({...data, activePage: 1}, this.getInitialData)
            }
          }}
          onSorterValueChange={sortData => {
            this.setState(
              {sort: `${sortData.column} ${sortData.asc ? 'asc' : 'desc'}`},
              this.getInitialData
            )
            console.log('onSorterValueChange', sortData)
          }}
          totalCount={this.state.itemsCount}
          title="Data Etiket"
          onRefreshPress={() => {
            // Reset filter, sorting & paging
            // Filter untuk pencarian web
            const defData = {
              sort: 'etinama ASC',
              activePage: 1,
              etinama: '',
              etiketerangan: '',
              etiaktif: 1,
            }
            this.setState(defData)
            this.getInitialData(defData)
          }}
          columnFilterValue={{
            etinama: '',
            etiaktif: 1,
          }}
          sorterValue={{column: 'etinama', asc: true}}
          statusColName="etiaktif"
          onActivate={item => this.aktifkan({...item, uid})}
        />
      </VmView>
    )
  }
}

function withParams(Component) {
  return props => {
    const [searchParams] = useSearchParams()
    return <Component {...props} searchParams={searchParams} />
  }
}

export default withParams(PrdDiagnosa)
